import m from "./index592.js";
import { isArray as O, isString as V } from "./index575.js";
import { rangeArr as I } from "./index578.js";
const _ = (r) => {
  if (!O(r)) return !1;
  const [e, i] = r;
  return m.isDayjs(e) && m.isDayjs(i) && m(e).isValid() && m(i).isValid() && e.isSameOrBefore(i);
}, g = (r, { lang: e, step: i = 1, unit: o, unlinkPanels: s }) => {
  let n;
  if (O(r)) {
    let [c, y] = r.map((S) => m(S).locale(e));
    return s || (y = c.add(i, o)), [c, y];
  } else r ? n = m(r) : n = m();
  return n = n.locale(e), [n, n.add(i, o)];
}, k = (r, e, {
  columnIndexOffset: i,
  startDate: o,
  nextEndDate: s,
  now: n,
  unit: c,
  relativeDateGetter: y,
  setCellMetadata: S,
  setRowMetadata: d
}) => {
  for (let h = 0; h < r.row; h++) {
    const p = e[h];
    for (let t = 0; t < r.column; t++) {
      let f = p[t + i];
      f || (f = {
        row: h,
        column: t,
        type: "normal",
        inRange: !1,
        start: !1,
        end: !1
      });
      const A = h * r.column + t, l = y(A);
      f.dayjs = l, f.date = l.toDate(), f.timestamp = l.valueOf(), f.type = "normal", f.inRange = !!(o && l.isSameOrAfter(o, c) && s && l.isSameOrBefore(s, c)) || !!(o && l.isSameOrBefore(o, c) && s && l.isSameOrAfter(s, c)), o?.isSameOrAfter(s) ? (f.start = !!s && l.isSame(s, c), f.end = o && l.isSame(o, c)) : (f.start = !!o && l.isSame(o, c), f.end = !!s && l.isSame(s, c)), l.isSame(n, c) && (f.type = "today"), S?.(f, { rowIndex: h, columnIndex: t }), p[t + i] = f;
    }
    d?.(p);
  }
}, u = (r, e, i, o) => {
  const s = m().locale(o).startOf("month").month(i).year(e).hour(r.hour()).minute(r.minute()).second(r.second()), n = s.daysInMonth();
  return I(n).map((c) => s.add(c, "day").toDate());
}, j = (r, e, i, o, s) => {
  const n = m().year(e).month(i).startOf("month").hour(r.hour()).minute(r.minute()).second(r.second()), c = u(r, e, i, o).find((y) => !s?.(y));
  return c ? m(c).locale(o) : n.locale(o);
}, M = (r, e, i) => {
  const o = r.year();
  if (!i?.(r.toDate()))
    return r.locale(e);
  const s = r.month();
  if (!u(r, o, s, e).every(i))
    return j(r, o, s, e, i);
  for (let n = 0; n < 12; n++)
    if (!u(r, o, n, e).every(i))
      return j(r, o, n, e, i);
  return r;
}, w = (r, e, i, o) => {
  if (O(r))
    return r.map(
      (s) => w(s, e, i, o)
    );
  if (V(r)) {
    const s = o?.value ? m(r) : m(r, e);
    if (!s.isValid())
      return s;
  }
  return m(r, e).locale(i);
};
export {
  k as buildPickerTable,
  w as correctlyParseUserInput,
  u as datesInMonth,
  g as getDefaultValue,
  j as getValidDateOfMonth,
  M as getValidDateOfYear,
  _ as isValidRange
};
